/* eslint-disable */
import { PriviewPpt } from '@/components/liveAndPlayback/pptPagination/PreviewPpt';
import { PptImg } from '@/components/liveAndPlayback/livePlaybackNotStart/PptImg';
import { Loading } from '@/components/loading/Loading';

export const LiveAndPlayBack = ({ state }: { state: { status: string; warmup: boolean; stream: string; musicName: string; } }) => {
  return (
    <>
      {state.status === 'loading' ? (
        <Loading></Loading>
      ) : state.status === 'prior' || state.status === 'post' ? (
        <PptImg {...state}></PptImg>
      ) : (
        <PriviewPpt {...state}></PriviewPpt>
      )}
    </>
  );
};
